<p-dialog header="QEC Datasets"
[modal]="true"
[style]="{width: '95vw'}" [(visible)]="visible" (onHide)="closeDialog()" [draggable]="false" >
<p-toast></p-toast>

<app-table-summary-sidebar
    [sidebarVisible]="sidebarVisible"
    (emitSidebarUpdate)="updateSidebar($event)"
    [summaryData]="summaryData"
    [header]="headerSummary"
    [documentName]="summaryDocumentName"
    [deltaTable]="deltaTableForSummary"
>
</app-table-summary-sidebar>
    <div class="docContainer">
      <div class="flex justify-content-end">
          <div class="flexEnd">
            <div class="p-input-icon-left searchContainer">
              <i class="pi pi-search"></i>
              <input
                  pInputText
                  class="searchInput p-inputtext pr-5"
                  type="text"
                  (keydown)="this.searchTextUpdate.next($event)"
                  [(ngModel)]="searchText"
                  placeholder="Search Tables"
              />
              <i
                  *ngIf="searchText?.length > 0"
                  (click)="searchText = ''; isloading=true;  tablesList=[]; getAllDeltaTables()"
                  class="pi pi-times cursor searchCancel"
              ></i>
          </div>
              <!-- <button
                  type="button"
                  [disabled]="selectedTables.length === 0"
                  (click)="checkChatDocs()"
                  class="p-button p-button-primary btnPadding"
              >
                  <span
                      *ngIf="chatwithDocs"
                      class="loaderSpinnerWhite mr-2"
                  ></span>
                  Chat with Tables
              </button> -->
          </div>
      </div>

      <div>
          <div *ngIf="isloading" class="loadingContainer">
              <app-loader [isLoading]="isloading"></app-loader>
          </div>
          <div
              class="ngTable"
              (scroll)="scrollUpdate.next($event)"
              *ngIf="!isloading"
          >
              <p-table
                  [columns]="displayedColumns"
                  [value]="tablesList"
                  scrollHeight=" calc(100vh - 280px)"
                  [(selection)]="selectedTables"
              >
                  <ng-template pTemplate="header" let-columns>
                      <tr>
                          <th class="checkbox">
                              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                          </th>
                          <th class="nameCol">Table</th>
                          <th class="uploadedAt">Source</th>
                          <th class="aboutCol-width">About</th>
                      </tr>
                  </ng-template>
                  <ng-template
                      pTemplate="body"
                      let-rowData
                      let-columns="columns"
                      let-rowIndex="rowIndex"
                  >
                      <tr [pSelectableRow]="rowData.tableId">
                          <td>
                              <p-tableCheckbox
                                  [value]="rowData"
                              ></p-tableCheckbox>
                          </td>
                          <td   tooltipPosition="top"
                          pTooltip="{{
                              rowData?.tableName | titlecase
                          }}" class="nameCol">{{ rowData.tableName.length>50 ? (rowData.tableName | slice : 0 : 48)+'...':rowData.tableName }}</td>
                          <td>
                              {{rowData.source}}
                          </td>
                          <td class="aboutCol-width">
                            <div  class="hyperlink" (click)="showAbout(rowData)">
                                 Click here to see data dictionary
                            </div>

                          </td>
                      </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage" class="emptymessage">
                      <tr>
                          <td colspan="12">
                              <div class="noData">No Document Available</div>
                          </td>
                      </tr>
                  </ng-template>
              </p-table>
          </div>
          <div
              *ngIf="loadmoreLoading && tablesList.length > 0 && !isloading"
              class="flexEnd load-more mt-1"
          >
              Loading...
          </div>
      </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end">
      <button
          type="button"
          [disabled]="selectedTables.length === 0"
          (click)="checkChatDocs()"
          class="p-button p-button-primary btnPadding"
      >
          <span
              *ngIf="chatwithDocs"
              class="loaderSpinnerWhite mr-2"
          ></span>
          Chat with Tables
      </button>
    </div>
  </ng-template>
</p-dialog>

